export type TooltipPosition = 'above' | 'below' | 'left' | 'right';

export const TOOLTIP_PANEL_CLASS = 'app-tooltip-panel';
